module.exports = __webpack_public_path__ + "img/35.7ae5521f.png";